/**
 * Storage Explorer Feature Module (Azure Storage engine, S1)
 *
 * Registers the `storage-explorer` workspace type. Registration side effect
 * only — the tab component stays behind the lazy chunk (deadlock-analyzer
 * precedent). Openers import `utils/openStorageExplorerTab` directly.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';
import { registerS2StorageMutationExtensions } from './mutations';
import { registerS4StorageExtensions } from './entities/tree/s4Extensions';
import { registerS8HnsExtensions } from './hns';

registerS2StorageMutationExtensions();
registerS4StorageExtensions();
registerS8HnsExtensions();

registerWorkspaceComponent(
  'storage-explorer',
  lazyWorkspaceTab(() => import('./components/StorageExplorerTab').then((m) => ({ default: m.StorageExplorerTab }))),
);
